import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_ENDPOINTS } from '../config/api';
import { useUniversalAuth } from '../hooks/useUniversalAuth'; // 🆕
import Navbar from './Navbar';


function Step4Payment({ userData }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [checkoutUrl, setCheckoutUrl] = useState('');
  const { checkToken, setToken } = useUniversalAuth(); // 🆕 Universal token

  // ✅ FIXED: NO MORE LOGIN BLOCKS + Universal auth
  useEffect(() => {
    const initAuthAndCheckout = async () => {
      try {
        // 🆕 Universal token detection (Android/iOS/Web)
        const token = checkToken();
        console.log('🔍 Universal token found:', !!token);
        
        if (token) {
          setToken(token); // Persist everywhere
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        // ✅ NO MORE: if (!token) alert('login') ❌ REMOVED

        // Auto checkout - Backend handles auth via JWT
        if (userData.selectedPlan?.priceId) {
          await createCheckoutSession();
        }
      } catch (err) {
        console.error('❌ Init error:', err);
      }
    };
    
    initAuthAndCheckout();
  }, [userData, checkToken, setToken]);

  const createCheckoutSession = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await axios.post(API_ENDPOINTS.createSubscriptionAuto, {
        priceId: userData.selectedPlan?.priceId
      });
      
      console.log('✅ Checkout response:', response.data);
      setCheckoutUrl(response.data.checkoutUrl);
    } catch (err) {
      console.error('❌ Checkout error:', err.response?.data);
      setError(err.response?.data?.error || 'Failed to create checkout session');
    } finally {
      setLoading(false);
    }
  };

const handleCheckout = () => {
  if (checkoutUrl) {
    console.log('🆕 Checkout URL:', checkoutUrl);
    
  
    if (window.Flutter) {
 
      window.Flutter.postMessage(JSON.stringify({
        type: 'OPEN_STRIPE',
        url: checkoutUrl
      }));
      toast.success('Opening secure payment...');
    } else {
   
      window.location.href = checkoutUrl;
    }
  }
};


  // ✅ SAME JSX - No changes needed
  return (
    <>
      <Navbar />
      <div className="container py-5" style={{ minHeight: '80vh' }}>
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            {/* Progress Bar */}
            <div className="progress-bar mb-4">
              <div className="progress" style={{ width: '100%' }}></div>
            </div>

            <div className="card shadow-lg border-0">
              <div className="card-body p-4 p-md-5">
                <h2 className="fw-bold mb-2">Complete Your Subscription</h2>
                <p className="text-muted mb-4">Step 4 of 4 - Secure Checkout</p>

                {/* Selected Plan Summary */}
                <div className="bg-gradient-light p-4 rounded-3 mb-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="fw-bold mb-1">{userData.selectedPlan?.name} Plan</h5>
                      <p className="text-muted mb-0">Monthly subscription</p>
                    </div>
                    <div className="text-end">
                      <h3 className="fw-bold text-primary mb-0">
                        ${userData.selectedPlan?.price}
                        <small className="text-muted">/mo</small>
                      </h3>
                    </div>
                  </div>
                  
                  <hr className="my-3" />
                  <div className="small text-muted">
                    <p className="mb-1">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Cancel anytime
                    </p>
                    <p className="mb-1">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Auto-renews monthly
                    </p>
                    <p className="mb-0">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Secure Stripe checkout
                    </p>
                  </div>
                </div>

                {/* Loading State */}
                {loading && (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary mb-3" 
                         role="status" 
                         style={{ width: '3rem', height: '3rem' }}>
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="text-muted">Preparing secure checkout with Stripe...</p>
                  </div>
                )}

                {/* Error State */}
                {error && (
                  <div className="alert alert-danger mb-4">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    {error}
                    <div className="mt-2">
                      <button 
                        onClick={() => window.location.reload()} 
                        className="btn btn-outline-danger btn-sm"
                      >
                        Try Again
                      </button>
                    </div>
                  </div>
                )}

                {/* Checkout Button */}
                {checkoutUrl && !loading && !error && (
                  <div className="text-center py-5">
                    <h4 className="mb-4">Ready to activate your subscription?</h4>
                    <p className="text-muted mb-4">
                      You'll be securely redirected to Stripe to complete payment.
                    </p>
                    
                    <button 
                      onClick={handleCheckout}
                      className="btn btn-primary btn-lg px-5 py-3"
                      style={{ fontSize: '1.1rem' }}
                    >
                      <i className="bi bi-lock-fill me-2"></i>
                      Pay ${userData.selectedPlan?.price}/month - Secure Checkout
                    </button>
                    
                    <div className="mt-4 pt-3 border-top">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-shield-check me-1 text-success"></i>
                        Powered by Stripe • Your data stays secure
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Trust Indicators */}
            {!loading && !error && checkoutUrl && (
              <div className="text-center mt-4">
                <div className="row g-3 justify-content-center">
                  <div className="col-auto">
                    <div className="text-primary">
                      <i className="bi bi-shield-check fs-3"></i>
                    </div>
                    <small className="text-muted">SSL Secured</small>
                  </div>
                  <div className="col-auto">
                    <div className="text-primary">
                      <i className="bi bi-credit-card fs-3"></i>
                    </div>
                    <small className="text-muted">All Cards</small>
                  </div>
                  <div className="col-auto">
                    <div className="text-primary">
                      <i className="bi bi-shield-shaded fs-3"></i>
                    </div>
                    <small className="text-muted">Stripe Verified</small>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Step4Payment;
